import { state } from "./state";

interface ApiRequestParams {
	host: string;
	method: string;
	onTimeout: () => void;
	path: string;
}

export class Api {
	delete(path: string): ApiRequest {
		return new ApiRequest({
			host: this.#host,
			method: "DELETE",
			onTimeout: (): void => this.#onTimeout(),
			path: path,
		});
	}

	get(path: string): ApiRequest {
		return new ApiRequest({
			host: this.#host,
			method: "GET",
			onTimeout: (): void => this.#onTimeout(),
			path: path,
		});
	}

	post(path: string): ApiRequest {
		return new ApiRequest({
			host: this.#host,
			method: "POST",
			onTimeout: (): void => this.#onTimeout(),
			path: path,
		});
	}

	put(path: string): ApiRequest {
		return new ApiRequest({
			host: this.#host,
			method: "PUT",
			onTimeout: (): void => this.#onTimeout(),
			path: path,
		});
	}

	#host: string;
	#onTimeout: () => void;

	constructor(host: string, onTimeout: () => void) {
		this.#host = host;
		this.#onTimeout = onTimeout;
	}
}

class ApiRequest {
	async do(): Promise<Response> {
		await Promise.all(this.#promises);

		let url = `https://${this.#host}${this.#path}`;
		if (this.#query) url += this.#query;

		return await fetch(url, {
			body: this.#body,
			headers: this.#headers,
			method: this.#method,
			signal: AbortSignal.timeout(this.#timeout),
		}).catch((err) => {
			if (err instanceof DOMException && err.name === "TimeoutError") {
				this.#onTimeout();
			}
			throw err;
		});
	}

	setBasicAuth(username: string, password: string): void {
		const base64String = Buffer.from(`${username}:${password}`).toString(
			"base64",
		);
		this.#headers.set("Authorization", `Basic ${base64String}`);
	}

	setBody(data: BodyInit): void {
		this.#body = data;
	}

	setJsonBody(data: unknown): void {
		this.#body = JSON.stringify(data);
		this.#headers.set("Content-Type", "application/json");
	}

	setSignedInUserAuth(): void {
		const promise = state.getTokenString().then((tokenString) => {
			this.#headers.set("Authorization", `Bearer ${tokenString}`);
		});
		this.#promises.push(promise);
	}

	setTimeout(ms: number): void {
		this.#timeout = ms;
	}

	#body: BodyInit | null | undefined;
	#headers = new Headers();
	#host: string;
	#method: string;
	#onTimeout: () => void;
	#path: string;
	#promises: Promise<unknown>[] = [];
	#query = "";
	#timeout = 30e3; // milliseconds

	constructor(args: ApiRequestParams) {
		this.#host = args.host;
		this.#method = args.method;
		this.#method = args.method;
		this.#onTimeout = args.onTimeout;
		this.#path = args.path;
	}
}
